import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalService } from './global/global.service';
import { Router } from '@angular/router';

@Injectable()
export class PublicInterceptor implements HttpInterceptor {
  requests = 0;
  constructor(private globalService: GlobalService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiLogin : 'fondos-frontend'}/public`,
      )
      || req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiLogin : 'fondos-frontend'}/usuario/clave/validar`,
      )
      || req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiLogin : 'fondos-frontend'}/usuario/clave/grabar`,
      )  
      || req.url.includes(
        `${this.globalService.globalEnvironments ? this.globalService.globalEnvironments.apiEndpoint.apiLogin : 'fondos-frontend'}/usuario/clave/correo`,
      )  
    ) {
      const reqClone = req.clone({
        headers: new HttpHeaders().set('x-api-key', this.globalService.globalEnvironments.apiKey),
        params: new HttpParams().set('g-recaptcha-response', this.globalService.reCaptchaToken),
      });

      return next.handle(reqClone).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          this.globalService.hideLoading();
          this.requests = 0;
          this.router.navigate(['/'], { state: { status: errorResponse.error.resultado } });
          return throwError('Server error');
        })
      );
    }

    return next.handle(req);
  }
}
